// export const version = process.env.npm_package_version
export const version = '1.1.5-beta.0';
